import React from 'react';

import './styles.scss'

export default ({formCtx = {}}) => {
  const error = ((formCtx.state || {}).errors || {}).request;

  return !!error && (
    <div id="requestError" className="request-error">
      {error}
    </div>
  )
}
